import { motion, AnimatePresence } from "framer-motion";
import useHandoffForm from "./useHandoffForm";
import HandoffForm from "./HandoffForm";
import HandoffSuccess from "./HandoffSuccess";
import { fadeOverlay, slideUpSheet } from "./motionVariants";

/**
 * Inline handoff sheet that slides up inside the chat panel. Submits a tagged
 * contact_message to /api/contact so it surfaces in /admin/messages and triggers
 * the existing Resend email to Dorothy + Valerie.
 */
export default function HandoffSheet({ open, onClose, onSubmitted, defaultName }) {
    const form = useHandoffForm({ defaultName, onSubmitted });

    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    {...fadeOverlay}
                    className="absolute inset-0 z-10 bg-[#0E2A47]/30 backdrop-blur-[2px] flex items-end"
                    onClick={onClose}
                    data-testid="handoff-overlay"
                >
                    <motion.div
                        {...slideUpSheet}
                        onClick={(e) => e.stopPropagation()}
                        className="w-full bg-white rounded-t-3xl border-t border-[#E5DFD3] shadow-xl max-h-[92%] overflow-y-auto"
                        data-testid="handoff-sheet"
                    >
                        {form.done ? <HandoffSuccess /> : <HandoffForm form={form} onClose={onClose} />}
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
